import type {
  CreateOrderReq,
  CreateOrderResp,
  MembershipPlanView,
  OrderView,
  PaywallConfigView,
  ProductView,
} from '@guanwei/shared';
import { api } from './api';

// ============================================================
// 商业化（用户端只读）
// ============================================================

export async function fetchMembershipPlans(): Promise<MembershipPlanView[]> {
  return api.get<MembershipPlanView[]>('/business/plans', { auth: false });
}

export async function fetchProducts(): Promise<ProductView[]> {
  return api.get<ProductView[]>('/business/products', { auth: false });
}

export async function fetchProduct(code: string): Promise<ProductView | null> {
  return api.get<ProductView | null>(`/business/products/${code}`, { auth: false });
}

export async function fetchPaywall(scene: string): Promise<PaywallConfigView | null> {
  return api.get<PaywallConfigView | null>(`/business/paywalls/${scene}`, {
    auth: false,
  });
}

// ============================================================
// 订单
// ============================================================

export async function createOrder(req: CreateOrderReq): Promise<CreateOrderResp> {
  return api.post<CreateOrderResp>('/orders', req);
}

export function submitPayment(order: CreateOrderResp): boolean {
  if (order.payment?.url && order.payment.params) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = order.payment.url;
    form.target = '_self';

    Object.entries(order.payment.params).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    return true;
  }

  if (order.payUrl) {
    window.location.href = order.payUrl;
    return true;
  }

  return false;
}

export async function cancelOrder(orderNo: string) {
  return api.post<{ orderNo: string; status: string }>('/orders/cancel', { orderNo });
}

export async function fetchMyOrders(page = 1, pageSize = 20) {
  return api.get<{
    list: OrderView[];
    total: number;
    page: number;
    pageSize: number;
  }>(`/orders?page=${page}&pageSize=${pageSize}`);
}

export async function fetchOrderDetail(orderNo: string) {
  return api.get<OrderView>(`/orders/${orderNo}`);
}
